export default `
    img{
        width: 50%;
        margin: 0 25%;
    }
`;